module.exports = __webpack_public_path__ + "img/hypertention.d7d83685.png";